import React, { Component, HTMLAttributes } from "react";
import { FormFieldProps, FormField } from "../../commonTypes/formField.types";
import { hashCode } from "../../utils/hash";

export interface RadioButtonProps<T = string | boolean>
  extends FormFieldProps<T> {
  checked?: boolean;
}

export interface RadioButtonState<T = string | boolean> extends FormField<T> {
  stringValue: string;
  checked: boolean;
}

export class RadioButton<T = string | boolean> extends Component<
  RadioButtonProps<T>,
  RadioButtonState<T>
> {
  static defaultProps = {
    fieldName: "",
    value: "",
    isRequired: false,
    isTouched: false,
    errorMessage: "",
    label: "",
    onChange: () => {
      /* noop */
    },
    onBlur: () => {},
  } as RadioButtonProps<any>;

  static getDerivedStateFromProps(
    props: RadioButtonProps<any>,
    state: RadioButtonState<any>
  ) {
    const { value, checked } = props;

    return {
      value,
      stringValue: String(value),
      checked,
    };
  }

  private _id: string;
  private _errorId: string;

  constructor(props) {
    super(props);
    this._id = props.id || hashCode(props.fieldName, "radioButton");
    this._errorId = hashCode(props.id || props.fieldName, "error");
    const { fieldName, value, isRequired, label, checked } = this.props;

    this.state = {
      value,
      stringValue: String(value),
      fieldName,
      isRequired,
      checked,
      errorMessage: "",
    };
  }

  private get _ariaAttributes(): HTMLAttributes<any> {
    const { errorAriaAttributes } = this.props;
    if (errorAriaAttributes) return errorAriaAttributes;
    if (this._errorMessage)
      return { "aria-invalid": true, "aria-describedby": this._errorId };
    return {};
  }

  render() {
    const { fieldName, label, children, isRequired, disabled, hidden } =
      this.props;
    const { stringValue, checked } = this.state;
    const text = label || children; // todo remove children when no radio buttons use it for label anymore..
    return (
      <div className={`form-group-xs-small ${hidden ? "d-none" : ""}`}>
        <label
          className={`radio-checkbox-label ${disabled ? "disabled-input" : ""}`}
        >
          <input
            type="radio"
            value={stringValue}
            name={fieldName}
            checked={checked}
            onBlur={this.handleOnBlur}
            onChange={this.handleOnChange}
            required={isRequired}
            disabled={disabled}
            {...this._ariaAttributes}
          />
          {text}
        </label>
      </div>
    );
  }

  private handleOnBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    this.setState(
      {
        isTouched: true,
      },
      () => {
        this.props.onBlur(e);
      }
    );
  };

  private handleOnChange = (e: React.ChangeEvent) => {
    //const payload = this.constructCurrentState(e.target.value, e.target.checked);
    this.setState(
      {
        isTouched: true,
        // value: payload.value,
        // stringValue: payload.stringValue,
        // checked: payload.checked
      },
      () => {
        this.props.onChange(this.state);
      }
    );
  };

  // private constructCurrentState = (val: string, isChecked: boolean): RadioButtonState<any> => {
  //   return {
  //     ...this.state,
  //     value: val,
  //     stringValue: String(val),
  //     checked: isChecked
  //   };
  // };

  private get _errorMessage(): string | undefined {
    let { errorMessage } = this.state;
    if (!errorMessage && this.props.errorMessage) {
      errorMessage = this.props.errorMessage;
    }

    return errorMessage;
  }
}
